import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Layout, PageHeader } from 'antd'

import SearchBar from './SearchBar'
import List from './List'

import { users } from '@services/api'

import { getQueryStringParams } from '@utils/index'

class Clients extends Component<any, any> {
    state = {
        data: {},
        searchParams: {},
        paramsRules: [
            'page',
            'first_name',
            'last_name',
            'identity',
            'phone',
            'parent_id',
            'role_id',
            'status',
            'subscription_id',
            'agency_id',
            'id',
            'slug',
            'email',
            'agent_id'
        ],
        loading: true
    }

    _isMounted = false
    _searchSeq = 0

    componentDidMount() {
        this._isMounted = true
        // Build params from the initial URL so the first API request honors the
        // query string the user navigated to (deep links / refreshes).
        this.runSearch(this.getParamsFromUrl())
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            const paramsFromUrl = this.normalizeSearchParams(this.getParamsFromUrl())
            if (this.getQueryString(paramsFromUrl) !== this.getQueryString(this.state.searchParams)) {
                this.runSearch(paramsFromUrl, { redirect: false })
            }
        }
    }

    getParamsFromUrl = () => {
        const newParams = getQueryStringParams(this.props.location.search)
        const { paramsRules } = this.state
        const params = {}
        paramsRules.forEach(key => (params[key] = newParams[key] ? newParams[key] : null))
        return params
    }

    // Single source of truth for params: guarantees `page` defaults to 1 so the
    // URL and the API request can never diverge.
    normalizeSearchParams = (params: any = {}) => {
        const normalized: any = { ...params }
        if (!normalized.page) normalized.page = '1'
        return normalized
    }

    getQueryString = (params: any = {}) => {
        const { paramsRules } = this.state
        const parts = []
        paramsRules.forEach(key => {
            const value = params[key]
            if (value !== null && value !== undefined && value !== '') {
                parts.push(`${key}=${encodeURIComponent(value)}`)
            }
        })
        return parts.join('&')
    }

    getApiSearchParams = (params: any = {}) => {
        const { paramsRules } = this.state
        const normalized = this.normalizeSearchParams(params)
        const apiParams: any = {}

        paramsRules.forEach(key => {
            const value = normalized[key]
            if (value !== null && value !== undefined && value !== '') {
                apiParams[key] = value
            }
        })

        if (apiParams.phone && apiParams.phone.length === 10 && apiParams.phone[0] === '0') {
            apiParams.phone = apiParams.phone.substr(1)
        }

        return apiParams
    }

    // Normalize once, then drive state, URL and API from the same object.
    runSearch = (params, options: any = {}) => {
        const normalized = this.normalizeSearchParams(params)
        this.setState({ searchParams: normalized }, () => {
            if (options.redirect !== false) this.redirect(normalized)
            this.initSearchQuery(normalized)
        })
    }

    resetSearchQuery = () => {
        this.runSearch({})
    }

    updateSearchQuery = () => {
        this.runSearch({ ...this.state.searchParams, page: '1' })
    }

    updatePage = value => {
        this.runSearch({ ...this.state.searchParams, page: value })
    }

    updateParam = (name, value) => {
        this.setState(prevState => ({ searchParams: { ...prevState.searchParams, [name]: value } }))
    }

    redirect = (paramsArg = this.state.searchParams) => {
        // Read from already-normalized state; never mutate it here.
        const qs = this.getQueryString(paramsArg)
        const nextUrl = `/clients${qs ? `?${qs}` : ''}`
        const currentUrl = `${this.props.location.pathname}${this.props.location.search}`
        if (currentUrl !== nextUrl) this.props.history.push(nextUrl)
    }

    initSearchQuery = paramsArg => {
        // Tag each request; only the latest one is allowed to write results, so a
        // slow earlier response can't overwrite a newer search/pagination.
        const seq = ++this._searchSeq
        this.setState({ loading: true }, async () => {
            try {
                const searchParams = this.getApiSearchParams(paramsArg || this.state.searchParams)
                const data = (await users.getClientList(searchParams)).data
                if (!this._isMounted || seq !== this._searchSeq) return
                this.setState({ data, loading: false })
            } catch (e) {
                console.log(e)
                if (!this._isMounted || seq !== this._searchSeq) return
                // Stop loading and preserve a safe data shape on error.
                this.setState(prevState => ({ loading: false, data: prevState.data || {} }))
            }
        })
    }

    render() {
        const { data, loading, searchParams } = this.state
        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="לקוחות רשומים במערכת"
                    subTitle={`מציג ${data['total'] || '0'} משתמשים`}
                >
                    <SearchBar
                        params={searchParams}
                        paramUpdated={(name, value) => this.updateParam(name, value)}
                        searchUpdated={() => this.updateSearchQuery()}
                        resetSearch={() => this.resetSearchQuery()}
                    />
                </PageHeader>
                <List data={data} loading={loading} updatePage={value => this.updatePage(value)} />
            </Layout>
        )
    }
}

export default withRouter(Clients)
